import React from 'react';
import { useInView } from 'react-intersection-observer';

import { Variant } from '../../types';
import { BoxShadow, Content, Wrapper } from './Body.styles';

export type Props = {
  children: React.ReactNode;
  bodyVariant?: Variant;
};

const Body = ({ children, bodyVariant = 'regular' }: Props) => {
  const [inViewRefTop, inViewTop] = useInView({ initialInView: true });
  const [inViewRefBottom, inViewBottom] = useInView({ initialInView: true });

  return (
    <Wrapper>
      <div ref={inViewRefTop} />
      {!inViewTop && <BoxShadow boxShadow="top" />}
      <Content bodyVariant={bodyVariant}>{children}</Content>
      {!inViewBottom && <BoxShadow boxShadow="bottom" />}
      <div ref={inViewRefBottom} />
    </Wrapper>
  );
};

export default Body;
